<div class="fixed-top" *ngIf="!noHeader">
  <div class="d-flex flex-column">
    <!-- <app-header [demoIcon]="demoIconFlag"></app-header>
    <app-breadcrumb></app-breadcrumb> -->

    <div class="my-2">
      <app-categorybar (emitValues)="getFilterValues($event)"></app-categorybar>
    </div>
  </div>
</div>

<div class="wrapper">
  <div class="top-section d-flex pt-3">
    <div class="title-section">
      <span class="custom_bigtitle">Skill&nbsp;Repository</span>
    </div>
    <div class="d-flex align-items-center">
      <div class="search-bar search" style="position: relative;">
        <input 
          type="search" style="margin-left: -1.5rem;" 
          [(ngModel)]="searchText" placeholder="Search for Employee by Name or Id..." (keyup)="validateSearchText()" (keyup)="handleKeyUp($event)" (keyup.enter)="searchButton()" [class.searchClose]="searchText == ''" class="search">
        <!-- tooltip message -->
        <div *ngIf="showTooltip" class="tooltip-message">
          Special characters are not allowed!
        </div>
        <button type="submit" class="search-icon" (click)="clearSearchText1()" *ngIf="searchText != ''">
          <i class="fa fa-times icon cancelSearch"></i>
        </button>
        <button type="submit" class="search-icon cancelSearch" (click)="searchButton()">
          <i class="fa fa-search icon"></i>
        </button>
      </div>
      <button class="mr-2 ml-2 export-btn" (click)="convertToPdf()" [disabled]="hide" *ngIf="!searchText">Export</button>
    </div>
  </div>
  
  <div class="mt-4">
    <app-skill-repo-employee-tiles *ngIf="showCards && data.length > 0" [data]="data"
      [comingFromGlobalSearch]="true"></app-skill-repo-employee-tiles>
      <div *ngIf="showCards && data.length === 0" class="no-data-message">
        <img src ="../../../assets/images/no_data.png" height="150px" >
        <br>
        <h4>No Result Found</h4>
  </div>
  </div>
  <div *ngIf="showviewMore" class="view-more-section pb-2 pt-3">
    <div class="view-more" (click)="viewMore()">View more</div>
  </div>
  <div class="skill-repo py-3" *ngIf="!showCards">
    <div class="flip-card skill-competency-tile pointer-cursor" *ngFor="let comp of dataWithCount">
      <div class="slide_card_container">
        <div class="flip-card-inner" (mouseenter)="onMouseEnter(comp.id)">
          <div class="comp-header-image" [ngStyle]="{
              background:
                'url(' + getImageSrc(comp.title) + ') no-repeat 0 0 / cover'
            }">
            <div>
              <h1 class="comp-main-count custom_bigtitle fw-400 mb-0">
                <span class="count-size">{{ comp.count }}</span>
              </h1>

              <h4 class="comp-main-header custom_titles mb-0">
                {{ comp.title }}
              </h4>
            </div>
          </div>
          <div class="flip-card-front" (click)="defaultTileNavigation(comp, $event)">
            <div class="">
              <div class="fliptitlecount">
                <h6 class="fliptitlecount custom_titles mb-0">
                  {{ comp.title }}<span>({{ comp.count }})</span>
                </h6>
              </div>
              <div class="submitted">*Submitted/Total</div>
              <div class="subcompcounts">
                <div class="flipsubcomp" *ngFor="let subcomps of flipSubcomp">
                  <div class="fliponesubcomp">
                    <div class="subcompname">
                      {{ subcomps.subCompetencyName }}
                    </div>
                    <div class="subcompcount">
                      {{ subcomps.submittedCount + subcomps.approvedCount }}/{{ subcomps.totalCount }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flip-card-back">
          <div class="children-content">
            <div class="comp-children" *ngFor="let data of comp.skillData; let i = index">
              <div class="row individual-comp-row pointer-cursor">
                <div class="col-7 pr-0 pl-0 custom_text">
                  <span class="dot-button" [style.background-color]="dotColors[i % dotColors.length]"></span>

                  {{ data.name }}
                </div>
                <div class="col-2 pl-5 custom_text">{{ data.count }}</div>
                <div class="col-1 pl-0 nav-image-holder" id="button-holder">
                  <img src="../../../assets/images/arrow_circle_right.svg" (click)="
                      navigateToSkilldata(
                        $event,
                        comp.title,
                        comp.id,
                        data.name
                      )
                    " class="edit-emp-nav" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isExport">
  <div class="content-download" #dataToExport>
    <div class="downloadcard pointer-cursor" *ngFor="let comp of dataWithCount">
      <div>
        <span>
          <h6 class="fliptitlecountdownload custom_titles mb-0">
            {{ comp.title }}<span>({{ comp.count }})</span>
          </h6>
        </span>
      </div>
      <div class="submitted">*Submitted/Total</div>
      <div class="subcompcounts">
        <div *ngFor="let subcomps of flipSubcompentencydownload">
          <div class="fliponesubcomp" *ngIf="subcomps.competencyId === comp.id">
            <div class="subcompname">
              {{ subcomps.subCompetencyName }}
            </div>
            <div class="subcompcount">
              {{ subcomps.submittedCount }}/{{ subcomps.totalCount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>